/* eslint-disable no-param-reassign */
import { Flex, MinusIcon, PlusIcon, Text } from '@pancakeswap/uikit';
import Select from "components/Select/SelectProvince";
import SelectToken from 'components/Select/SelectToken';
import SelectWidthImg from 'components/Select/SelectWidthImg';
import province from "config/constants/address/province.json";
import React, { useEffect, useMemo, useState } from 'react';
import NumberFormat from "react-number-format";
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'state';
import { GetDataGiftCards } from 'state/giftCards';
import { fetchActiveTokenPayment, fetchListProvince } from 'state/giftCards/actions';
import { BrandItem, Brandtype } from "state/giftCards/type";
import styled from 'styled-components';
import { ButtonQuanlity, CsFlex, GirdColum, WrapCount } from "../styles";


interface FilterProps {
    setFillAmount:(newValue: number) => void,
    fillAmount:number,
    selectBrand?:Brandtype,
    setSelectBrand:(newValue: Brandtype) => void,
    handleChangeInput:(newValue: any) => void,
    handleSelectReliGion:(newValue: any) => void,
    resultFilterProvince:Brandtype[],
    isError:boolean,
    isDefaultBrand:boolean,
    isDefaultProvince:boolean,
    setIsDefaultBrand:(newVallue: boolean) => void,
    stockQuantity:number,
    filterIsPrice:BrandItem,
    filterIsProduct:BrandItem,
    findProductRoute:BrandItem,
    cardPrice:BrandItem,
    cardProduct:BrandItem,
    viewTag:string,
    selectCategory:string,
    priceRoute?:string,
    brandRoute?:string,
    setOptionSelected:(newVallue: boolean) => void,
    optionSelected:boolean,
    setCardPrice?: (newVallue: boolean) => void,
}

const Filter:React.FC<FilterProps> = ({
    setFillAmount,
    fillAmount,
    setSelectBrand,
    selectBrand,
    handleChangeInput,
    handleSelectReliGion,
    resultFilterProvince,
    isError,
    isDefaultBrand,
    isDefaultProvince,
    setIsDefaultBrand,
    stockQuantity,
    filterIsPrice,
    filterIsProduct,
    findProductRoute,
    cardPrice,
    cardProduct,
    viewTag,
    selectCategory,
    priceRoute,
    brandRoute,
    setOptionSelected,
    optionSelected,
    setCardPrice
}) => {
    const dispatch = useDispatch<AppDispatch>()
    const dataGiftcards = GetDataGiftCards()
    const { ListBrand, ListProvinceByBrand: ListProvinceByBrandStore , isLoading, tokenSupport, activeTokenPayment } = dataGiftcards
    const [ listProvinceByBrandState, setListProvinceByBrandState] = useState([])
    const [selectedOption, setSelectedOption] = useState(null)
    useEffect(() => {
        if(ListProvinceByBrandStore){
            setListProvinceByBrandState(ListProvinceByBrandStore)
        }
    },[ListProvinceByBrandStore])

    const handleChangeFillAmount = (option) => {
        if( option === 1){
            setFillAmount(Number(fillAmount) - 1 )
        } 
        if (option === 2){
            setFillAmount(Number(fillAmount) + 1)
        }
    }

    const handleSelectBrand = (option) => {
        if(option === undefined){
            setSelectBrand(option?.id)
        }
        if (option !== undefined) {
            setSelectBrand(ListBrand?.find((item) => item?.id === option))
        }
        setCardPrice(null)
    };
    const handleSelectToken = (option) => {
        dispatch(fetchActiveTokenPayment({activeTokenPayment: option?.value}))
    };

    const allOption = [{
        provinceId: "0",
        provinceName: "Tất cả các tỉnh thành"
    }]

    const FilterIsBrandId = () => {
        const mapListProvinceByBrband:any[] = listProvinceByBrandState?.map((item) => {
            if(!item){
                return []
            }
            return province?.find((it) => it?.provinceId?.toString() === item?.toString())
        })
        const concatProvince = allOption?.concat(mapListProvinceByBrband)
        const filterRemoveUndefine = concatProvince?.filter((dt) => dt !== undefined)
        return filterRemoveUndefine
    }
    const resultFilterIsBrandId = FilterIsBrandId()

    useEffect(() => {
        if(resultFilterIsBrandId && Number(selectedOption?.provinceId) !== 0 && !Number.isNaN(Number(selectedOption?.provinceId)) ){
            dispatch(fetchListProvince({listProvince: resultFilterIsBrandId}))
        }
        // dispatch(fetchListProvince({listProvince: province}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[listProvinceByBrandState, selectedOption, selectBrand, isLoading, dispatch])
    const renderOptionsToken = useMemo(() => {
        const option = tokenSupport?.map((dt) => {
            return {
                label: dt?.token?.symbol,
                value: dt?.token?.address,
                tokens: dt?.token
            }
        })
        return option
    },[tokenSupport])
    useEffect(() => {
        if(!activeTokenPayment){
            dispatch(fetchActiveTokenPayment({activeTokenPayment: renderOptionsToken[0]?.value}))
        }
       
    },[activeTokenPayment, dispatch, renderOptionsToken])
    
  return (
    <GirdColum>
        <CsFlex mt="1rem">
            <div style={{width: '100%'}}>
                <Flex>
                    <Text fontWeight="bold">Tỉnh thành</Text>
                </Flex>
                <Select style={{marginTop: '10px'}}
                    options={resultFilterIsBrandId}
                    placeHolderText="Chọn tỉnh thành"
                    onOptionChange={(e) => handleSelectReliGion(e)}
                    isDefaultProvince={isDefaultProvince}
                    selectCategory={selectCategory}
                    isLoading={isLoading}
                    selectBrand={selectBrand}
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                    priceRoute={priceRoute}
                    brandRoute={brandRoute}
                    setOptionSelected={setOptionSelected}
                    optionSelected={optionSelected}
                />
            </div>
        </CsFlex>
        <CsFlex mt="1rem">
            <div style={{width: '100%'}}>
                <Flex mb="10px">
                    <Text fontWeight="bold">Thương hiệu</Text> <Text ml="4px" color="red">*</Text>
                </Flex>
                <SelectWidthImg
                    options={resultFilterProvince}
                    placeHolderText="Chọn thương hiệu"
                    onOptionChange={handleSelectBrand}
                    defaultValue={selectBrand}
                    isDefaultBrand={isDefaultBrand}
                    setIsDefaultBrand={setIsDefaultBrand}
                    isLoading={isLoading}
                />
                {
                    ( isError && selectBrand === undefined) && <Text fontSize={['14px', , '16px']} mt="0.5rem" color="red">Vui lòng chọn thương hiệu</Text>
                }
            </div>
        </CsFlex>
        <CsFlex mt="1rem">
            <div style={{width: '100%'}}>
                <Flex>
                    <Text fontWeight="bold">Số lượng đổi</Text> <Text ml="4px" color="red">*</Text>
                </Flex>
                <WrapCount style={{marginTop: '10px'}}>
                    <ButtonQuanlity
                        disabled={fillAmount < 2}
                        onClick={() => handleChangeFillAmount(1)}
                    >
                        <MinusIcon fill="white" />
                    </ButtonQuanlity>
                    <CsNumericFormat
                        value={fillAmount}
                        decimalScale={0}
                        thousandSeparator={!false}
                        placeholder="1"
                        // eslint-disable-next-line no-return-assign, no-param-reassign
                        onFocus={(e) => e.target.placeholder = ""} 
                        onChange={(evt) => {
                            const value = evt?.target?.value ;
                            handleChangeInput(value.split(",").join(""))
                        }}
                        maxLength={35}
                        allowNegative={false}                     
                    />
                    <ButtonQuanlity
                        disabled={fillAmount >= 30 || fillAmount >= stockQuantity}
                        onClick={() => handleChangeFillAmount(2)}
                    >
                        <PlusIcon />
                    </ButtonQuanlity>
                </WrapCount>

                {((isError && Number(fillAmount) <= 0) && (cardProduct || cardPrice)) && <Text color="red" mt="0.5rem" fontSize={['14px', , '16px']}>Số lượng đổi phải lớn hơn 0</Text>}
                {
                    ((viewTag === '2' && isError && (Number(fillAmount) > Number(stockQuantity)) && cardProduct) || (viewTag === '1' && isError && (Number(fillAmount) > Number(stockQuantity)) && cardPrice)) ?
                        <Text color="red" mt="0.5rem" fontSize={['14px', , '16px']}>Vui lòng nhập số lượng nhỏ hơn hoặc bằng {stockQuantity}</Text>
                    :
                    <>
                        {
                            (Number(fillAmount) > 30) && <Text color="red" mt="0.5rem" fontSize={['14px', , '16px']}>Vui lòng nhập số lượng nhỏ hơn hoặc bằng 30</Text>
                        }
                    </>
                }
                {
                    ((filterIsPrice || cardPrice) || (filterIsProduct || cardProduct) || findProductRoute) && !isDefaultBrand && (
                        <Flex maxWidth="100%" justifyContent={["space-between", ,"flex-end"]}  mt="1.5rem">
                            <Text width="50%" fontSize={['14px', , '16px']}>Số lượng còn lại</Text>
                            <Text textAlign="right" width="50%" fontSize={['14px', , '16px']}>{stockQuantity} thẻ quà</Text>
                        </Flex>
                    )
                }
            </div>
        </CsFlex>
        <CsFlex mt="1rem">
            <div style={{width: '100%'}}>
                <Flex mb="10px">
                    <Text fontWeight="bold">Phương thức quy đổi</Text>
                </Flex>
                <SelectToken
                    options={renderOptionsToken}
                    placeHolderText="Chọn phương thức quy đổi"
                    onOptionChange={handleSelectToken}
                    value={activeTokenPayment}
                />
            </div>
        </CsFlex>
    </GirdColum>
  )
}

export default Filter

export const CsNumericFormat = styled(NumberFormat)`
    background-color: transparent;
    outline: none;
    border: none;
    width: 100%;
    height: 100%;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color:${({ theme }) => theme.colors.text};
    &:focus-visible {
        outline: none;
    }
    ::placeholder { 
        color:${({ theme }) => theme.colors.text};
        opacity: 1; 
    }
`
function setSelectedToken(value: any) {
    throw new Error('Function not implemented.');
}

